import React from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Login from './Login'; 

const LoginWithCaptcha = (props) => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  return <Login {...props} executeRecaptcha={executeRecaptcha} />;
};

export default LoginWithCaptcha;
